import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  setEditId,
  setEditError,
  selectFeatureFlagSettingById
} from "src/store/callrecorder/featureFlagSettingsSlice";
import {
  fetchFeatureFlagSetting,
  updateFeatureFlagSetting
} from "src/actions/callrecorder/featureFlagSettingsActions";

import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";
import Form from './_partials/_Form';

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any  = useAppSelector(state => state.callrecorder.featureFlagSettings.editId);
  const error    = useAppSelector(state => state.callrecorder.featureFlagSettings.editError);
  const flag     = useAppSelector(state => selectFeatureFlagSettingById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchFeatureFlagSetting(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  async function onFinish(data: any) {
    const result = await dispatch(updateFeatureFlagSetting({ id, data }));
    if (updateFeatureFlagSetting.fulfilled.match(result)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-feature-flag'>
        <h6 className='v-content-label'>Edit Feature Flag</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={flag} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
